
import 'components/datatable.tag'
import 'pages/products/parameters/feature-new-edit-modal.tag'
import 'pages/products/parameters/parameters-groups-list-modal.tag'
riot.tag2('parameter-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/parameters"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование параметра\'}</div>\n    <div class="tab-content">\n      <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n        <div class="row">\n          <div class="col-md-2">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="shopfeature" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-10">\n            <div class="row">\n              <div class="col-md-10">\n                <div class="form-group {has-error: error.name}">\n                  <label class="control-label">Наименование</label>\n                  <input class="form-control" name="name" type="text" value="{item.name}">\n                  <div class="help-block">{error.name}</div>\n                </div>\n              </div>\n\n              <div class="col-md-2">\n                <div class="form-group {has-error: error.type}">\n                  <label class="control-label">Тип переменной</label>\n                  <select class="form-control" name="type" value="{item.type}">\n                    <option each="{feature, i in featuresTypes}" value="{feature.code}">{feature.name}</option>\n                  </select>\n                  <div class="help-block">{error.type}</div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-2">\n                <div class="form-group">\n                  <label class="control-label">Ед. изм.</label>\n                  <input class="form-control" name="measure" type="text" value="{item.measure}">\n                </div>\n              </div>\n              <div class="col-md-5">\n                <div class="form-group">\n                  <label class="control-label">Подсказка</label>\n                  <input class="form-control" name="placeholder" type="text" value="{item.placeholder}">\n                </div>\n              </div>\n              <div class="col-md-5">\n                <div class="form-group">\n                  <label class="control-label">Категория</label>\n                  <div class="input-group">\n                    <input class="form-control" name="nameGroup" type="text" value="{item.nameGroup}" readonly>\n                    <div class="input-group-btn">\n                      <div class="btn btn-default" onclick="{selectGroup}"><i class="fa fa-list text-primary"></i></div>\n                      <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="row">\n              <div class="col-md-12">\n                <div class="form-group">\n                  <label class="control-label">Описание</label>\n                  <textarea class="form-control" rows="5" name="description" style="min-width: 100%; max-width: 100%;" value="{item.description}"></textarea>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n      <div class="row" if="{listTypes.indexOf(item.type) !== -1}">\n        <div class="col-md-12">\n\n\n          <div class="form-group">\n            <label class="control-label">Список значений параметра</label><br>\n            <button class="btn btn-primary" onclick="{addFeatureValue}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n            <button class="btn btn-danger" if="{featuresSelectedCount}" onclick="{removeFeatureValue}" title="Удалить" type="button"><i class="fa fa-trash">{(featuresSelectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{featuresSelectedCount &gt; 1}">{featuresSelectedCount}</span></button>\n            <button class="btn btn-primary" if="{featuresSelectedCount &gt; 0}" onclick="{reorderNext}" title="Вниз" type="button"><i class="fa fa-arrow-down"></i></button>\n            <button class="btn btn-primary" if="{featuresSelectedCount &gt; 0}" onclick="{reorderPrev}" title="Вверх" type="button"><i class="fa fa-arrow-up"></i></button>\n            <div class="dropdown" style="display: inline-block;">\n              <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n              <ul class="dropdown-menu">\n                <li onclick="{sortAsc}"><a href="#"><i class="fa fa-fw fa-sort"></i> Сортировать по возрастанию</a></li>\n                <li onclick="{sortDesc}"><a href="#"><i class="fa fa-fw fa-sort"></i> Сортировать по убыванию</a></li>\n              </ul>\n            </div>\n          </div>\n          <datatable name="features" cols="{featuresValuesCols}" rows="{item.values}" dblclick="{editFeatureValue}" reorder="true">\n            <datatable-cell name="image" style="width: 50px; overflow: hidden;"><img if="{row.image.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 40px;"></datatable-cell>\n            <datatable-cell name="value"><i class="color" if="{parent.parent.parent.item.type === &quot;colorlist&quot;}" riot-style="background-color: {row.color};"></i>{row.value}</datatable-cell>\n            <datatable-cell name="code">{row.code}</datatable-cell>\n          </datatable>\n        </div>\n      </div>\n\n    </div>\n  </virtual>\n', 'parameter-edit .color,[riot-tag="parameter-edit"] .color,[data-is="parameter-edit"] .color{ height: 12px; width: 12px; display: inline-block; }', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.item = {};
self.listTypes = ['list', 'colorlist', 'check'];
self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = {
    name: 'empty',
    type: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.featuresValuesCols = [
//{name: 'id', value: '#'},
{ name: 'image', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'code', value: 'Код (URL)' }];

self.sortAsc = function () {
    self.item.values = self.item.values.sort(function (a, b) {
        var c = a.value,
            d = b.value;
        if (c * 1 > 0) c = c * 1;
        if (d * 1 > 0) d = d * 1;
        if (c < d) {
            return -1;
        } else if (c > d) {
            return 1;
        }
        return 0;
    });
    for (var i = 0; i < self.item.values.length; i++) {
        self.item.values[i]['sort'] = i;
    }
};

self.sortDesc = function () {
    self.item.values = self.item.values.sort(function (a, b) {
        var c = a.value,
            d = b.value;
        if (c * 1 > 0) c = c * 1;
        if (d * 1 > 0) d = d * 1;
        if (c > d) {
            return -1;
        } else if (c < d) {
            return 1;
        }
        return 0;
    });
    for (var i = 0; i < self.item.values.length; i++) {
        self.item.values[i]['sort'] = i;
    }
};

self.submit = function (e) {
    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'Feature',
            method: 'Save',
            data: self.item,
            success: function success(response) {
                self.item = response;
                popups.create({ title: 'Успех!', text: 'Параметр сохранен!', style: 'popup-success' });
                observable.trigger('parameters-groups-reload');
                self.update();
            }
        });
    }
};

self.reload = function () {
    observable.trigger('parameters-edit', self.item.id);
};

self.reorderNext = function () {
    self.tags['features'].reorderNext();
};

self.reorderPrev = function () {
    self.tags['features'].reorderPrev();
};

function getImageUrl(name) {
    if (name.indexOf('http://') == -1 && name.indexOf('https://') == -1) {
        return app.getImagePreviewURL(name, 'shopfeature');
    } else {
        return name;
    }
}

self.addFeatureValue = function () {
    modals.create('feature-new-edit-modal', {
        type: 'modal-primary',
        typeparam: self.item.type,
        submit: function submit() {
            var _this = this,
                params = {};

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                params.idFeature = self.item.id;
                params.value = _this.item.value;
                if (params.value.image && !params.value.imageUrlPreview) {
                    params.value.imageUrlPreview = getImageUrl(params.value.image);
                }

                self.item.values = [params].concat(self.item.values);
                self.update();
                this.modalHide();
            }
        }
    });
};

self.editFeatureValue = function (e) {
    modals.create('feature-new-edit-modal', {
        item: e.item.row,
        type: 'modal-primary',
        typeparam: self.item.type,
        submit: function submit() {
            e.item.row = this.item;
            if (e.item.row.image && !e.item.row.imageUrlPreview) {
                e.item.row.imageUrlPreview = getImageUrl(e.item.row.image);
            }
            self.update();
            this.modalHide();
        }
    });
};

self.removeFeatureValue = function () {
    self.item.values = self.tags.features.getUnselectedRows();
    self.update();
};

var getFeaturesTypes = function getFeaturesTypes() {
    return API.request({
        object: 'FeatureType',
        method: 'Fetch',
        data: {},
        success: function success(response) {
            self.featuresTypes = response.items;
            self.update();
        }
    });
};

self.selectGroup = function () {
    modals.create('parameters-groups-list-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length) {
                self.item.idFeatureGroup = items[0].id;
                self.item.nameGroup = items[0].name;
                self.update();
                this.modalHide();
            }
        }
    });
};
self.removeGroup = function (e) {
    self.item.idFeatureGroup = null;
    self.item.nameGroup = '';
};

observable.on('parameters-edit', function (id) {
    var params = { id: id };
    self.item = {};
    self.loader = true;
    self.error = false;
    self.featuresSelectedCount = 0;
    self.update();

    API.request({
        object: 'Feature',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.item = response;
            self.update({
                loader: false
            });
        },
        error: function error(response) {
            self.update({
                loader: false
            });
        }
    });
});

self.on('mount', function () {
    riot.route.exec();
});

self.on('updated', function () {
    if (self.listTypes.indexOf(self.item.type) !== -1) {
        self.tags.features.on('row-selected', function (count) {
            self.featuresSelectedCount = count;
            self.update();
        });
        self.tags.features.on('reorder-end', function () {
            self.item.values.forEach(function (item, index) {
                item.sort = index;
            });

            self.update();
        });
        self.off('updated');
    }
});

getFeaturesTypes();
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameter-edit.tag